import Vue from 'vue';
import Vuex from 'vuex';
import {getField, updateField} from 'vuex-map-fields';

Vue.use(Vuex);

const getDefaultState = () => {

    const getGuests = () => {
        const guests = {};
        if (!window.cartContent) {
            return guests;
        }
        let active = true, previous = null;

        Object.keys(window.cartContent).forEach((key) => {
            const productIndex = window.cartContent[key].id + '-' + window.cartContent[key].options.product_id;
            guests[key] = {
                name: window.cartContent[key].name,
                list: [],
                active: active,
                previous: previous,
                options: window.guest_fields.filter((item) => {
                    if (window.product_fields[productIndex] === undefined) { return false; }

                    return window.product_fields[productIndex].includes(item.key);
                }),
            };
            const defaultOptions = {};
            guests[key].options.forEach(item => {
                defaultOptions[item.key] = null;
            })
            guests[key].list.push({
                id: null,
                firstname: null,
                lastname: null,
                email: null,
                phone: null,
                date_of_birth: null,
                address_1: null,
                address_2: null,
                county: null,
                city: null,
                postal_code: null,
                country_id: null,
                document: null,
                nationality_id: null,
                options: structuredClone(defaultOptions),
                lead: true,
            });
            //guest_all_enabled
            if (window.product_guest_all_enabled[productIndex] !== undefined
                && window.product_guest_all_enabled[productIndex] === true
                && guests[key].list.length < window.cartContent[key].qty) {
                for (let guestCounter = 1, totalGuestsRequired = window.cartContent[key].qty - guests[key].list.length; guestCounter <= totalGuestsRequired; guestCounter++) {
                    guests[key].list.push({
                        id: null,
                        firstname: null,
                        lastname: null,
                        email: null,
                        phone: null,
                        date_of_birth: null,
                        address_1: null,
                        address_2: null,
                        county: null,
                        city: null,
                        postal_code: null,
                        country_id: null,
                        document: null,
                        nationality_id: null,
                        options: structuredClone(defaultOptions),
                        lead: false,
                    });
                }
            }

            active = false;
            previous = key;
        });

        return guests;
    };

    return {
        loading   : false,
        isCheckout   : true,
        paymentMethods   : window.paymentMethods ? window.paymentMethods : {},
        selectedPaymentMethod   : null,
        cartContent      : window.cartContent ? window.cartContent : {},
        subTotal         : window.cartTotal ? parseFloat(window.cartTotal) : {},
        cartTotal        : window.cartTotal ? parseFloat(window.cartTotal) : {},
        deliveryTotal    : 0,
        client_secret    : window.clientSecret ? window.clientSecret : '',
        invoices         : window.invoices ? window.invoices : [],
        currency         : window.currency ? window.currency : {},
        ticketCategories : window.ticketCategories ? window.ticketCategories : {},
        order            : {
            order_id: null,
            guests: getGuests(),
            delivery_method_id: {},
            hotel_address     : {
                name   : '',
                street : '',
                country: '',
                city   : '',
                zip    : '',
            },
            comments          : '',
            agency_reference  : '',
            requires_delivery: null,
        },
        errors           : {},
        errorsMessagesFromApi           : [],
        hasValidationErrors           : false,
        bookingButtonLabel: null,
    }
};

const state = getDefaultState();

export const store = new Vuex.Store({
    state,
    getters  : {
        getField,
    },
    mutations: {
        updateField
    },
    actions  : {
        removeItem({commit, state}, products) {

        }
    }
});
